import values from 'lodash/values';

export function buildChangesToSave(systemKey, changes) {
    const mappedChanges = values(changes).reduce(
        (result, change) => [
            ...result,
            {
                value: change.currentValue,
                kpiType: change.kpiType,
                kpiConfigurationKey: change.kpiConfigurationKey,
                itemId: change.itemConfigurationId,
            },
        ],
        []
    );

    const changeData = {
        systemChanges: mappedChanges
            .filter((change) => change.kpiType === 'system')
            .map((change) => ({
                kpiConfigurationKey: change.kpiConfigurationKey,
                defaultValue: change.value,
            })),
        itemChanges: {
            toChange: mappedChanges
                .filter((change) => change.value && change.kpiType !== 'system')
                .map((change) => ({
                    kpiConfigurationKey: change.kpiConfigurationKey,
                    value: change.value,
                    itemId: change.itemId,
                })),
            toRemove: mappedChanges
                .filter(
                    (change) =>
                        change.value == null && change.kpiType !== 'system'
                )
                .map((change) => ({
                    kpiConfigurationKey: change.kpiConfigurationKey,
                    itemId: change.itemId,
                })),
        },
        systemKey,
    };

    return changeData;
}

export function buildStateFromApiCall(configurations) {
    const systemValuesDictionary = configurations.systemValues.reduce(
        (acc, currentValue) => ({
            ...acc,
            [currentValue.kpiConfigurationKey]: currentValue.defaultValue,
        }),
        {}
    );

    const itemValuesDictionary = configurations.itemValues.reduce(
        (acc, currentValue) => ({
            ...acc,
            [`${currentValue.kpiConfigurationKey}.${currentValue.itemId}`]:
                currentValue.value,
        }),
        {}
    );

    return { ...systemValuesDictionary, ...itemValuesDictionary };
}

export function buildEnterpriseAndSortChanges(systemKey) {
    return (changes) => buildChangesToSave(systemKey, changes);
}
